export const REACT_APP_SERVER_DOMAIN =
  process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:44375";

export const REACT_APP_STREAM_CHAT_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://speech-api.tauga.ai/api/chat"
    : "http://localhost:4000/api/chat";